<template>
	<section>
		<location-hero
			:locationLabel="restListHeader.locationHero.locationLabel"
			:backgroundImage="restListHeader.locationHero.backgroundImage"
			:businessPhone="restListHeader.locationHero.businessPhone"
			:mapCenterLat="restListHeader.locationHero.mapCenterLat"
			:mapCenterLng="restListHeader.locationHero.mapCenterLng"
			:mapDefaultZoom="restListHeader.locationHero.mapDefaultZoom"
			:restListHeader="restListHeader"
			@clearSelectedFilters="handleClearFilters()"
		></location-hero>
		<category-filter-list
			:filters="tagList"
			:clearSelectedFilters="clearSelectedFilters"
			@filterSelected="clearSelectedFilters = false"
		></category-filter-list>
	</section>
</template>
<script>
import LocationHero from "./LocationHero.vue";
import CategoryFilterList from "./CategoryFilterList.vue";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
	components: {
		LocationHero,
		CategoryFilterList,
	},
	created() {
		this.setInitRestListHeaderState();
	},
	computed: {
		...mapState({
			tagList: (state) => state.restList.restListLarge.tagList,
			restListHeader: (state) => state.restList.restListHeader,
		}),
	},
	data: function () {
		return {
			clearSelectedFilters: false,
		};
	},
	methods: {
		...mapActions({
			setInitRestListHeaderState: "restList/setInitRestListHeaderState",
		}),
		...mapMutations({
			setTitleFilter: "restList/setTitleFilter",
		}),
		handleClearFilters() {
			this.clearSelectedFilters = true;
			this.setTitleFilter("");
		},
	},
};
</script>